import Banner from "../components/banner/Banner";
import CartItem from "../components/cart/CartItem";
import Navbar from "../components/navbar/Navbar";
import RelatedProducts from "../components/relatedProducts/RelatedProducts";
import "../components/cart/Cart.css"
import Footer from "../components/footer/Footer";
import { useEffect } from "react";

const Cart = () => {
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (

        <div className="bg-imagea">
            <Navbar />
            <Banner title="Cart" />
            <CartItem />
            {/* <RelatedProducts /> */}
<Footer/>
        </div>
    )
}
export default Cart;